import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import style from "./Input.module.css";

const FormInputTagField = ({
  name,
  label,
  required,
  control,
  rules,
  error,
}) => {
  return (
    <Box className={style.control}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => {
          //create an array of tags or empty array (if null or blank string)
          const tags =
            field.value === null || field.value === ""
              ? []
              : field.value.split(",");

          return (
            <Autocomplete
              sx={{
                "& .MuiInputBase-root": {
                  backgroundColor: "white",
                },
              }}
              multiple
              freeSolo
              value={tags}
              options={[]}
              onChange={(e, value) => {
                field.onChange(value?.join(","));
              }}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="contained"
                    label={option}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  required={required}
                  {...params}
                  error={error !== undefined}
                  label={label}
                  size="small"
                  helperText={error}
                />
              )}
            />
          );
        }}
      />
    </Box>
  );
};

export default FormInputTagField;
